import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LevelNameService {
  private readonly STORAGE_KEY = 'levelNames';

  updateLevelNames(names: any) {
    if (names) {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(names));
    }
  }

  getLevelNames(): any {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  }
}
